import { z } from 'zod';
// Sized to fit the `listeners` columns in apps/api/src/db/schema.ts, not Spotify's actual limits.
export const SPOTIFY_USER_ID_MAX_LENGTH = 64;
export const DISPLAY_NAME_MAX_LENGTH = 128;
export const SessionUserSchema = z
    .strictObject({
    spotifyId: z.string().min(1).max(SPOTIFY_USER_ID_MAX_LENGTH),
    displayName: z.string().min(1).max(DISPLAY_NAME_MAX_LENGTH),
    email: z.email().nullable(),
    avatarUrl: z.url().nullable(),
})
    .readonly();
export const AuthStatusSchema = z.discriminatedUnion('authenticated', [
    z.strictObject({
        authenticated: z.literal(true),
        user: SessionUserSchema,
        sessionExpiresAt: z.iso.datetime(),
    }),
    z.strictObject({
        authenticated: z.literal(false),
    }),
]);
// Non-strict: describes Spotify's payload; an extra field there must not break sign-in.
export const SpotifyCallbackQuerySchema = z.union([
    z.object({
        code: z.string().min(1),
        state: z.string().min(1),
    }),
    z.object({
        error: z.string().min(1),
        state: z.string().min(1).optional(),
    }),
]);
//# sourceMappingURL=auth.js.map